export class IncidenciaModel {

    id: number;
    actuacionRealizada: string;
    detalle: string;
    cierre:string;
    tasacionId:number;
    fechaInicio:Date;
    fechaCierre:Date;

    public constructor(){
        this.id = 0;
        this.actuacionRealizada = '';
        this.detalle = '';
        this.cierre = '';
        this.tasacionId = 0;
        this.fechaInicio = null;
        this.fechaCierre = null; 
    }
}